import Emitter from "es6-event-emitter";

import language from "./../../dictionary";
import voucherTemplate from "./../../templates/settings/settingVoucher.dust";
import { redeemAndStoreVoucher } from "../../services/voucher";
import { VOUCHER_EVENTS } from "../../analytics/analyticsevents";

const VOUCHER_CONTAINER_ID = "sidemenu-voucher-container";
const VOUCHER_ERROR_ID = "voucher-error";

export default class SettingVoucher extends Emitter {
  constructor(appState) {
    super();
    this._appState = appState;
    this.render();
  }

  render() {
    const context = {
      back: true,
      close: true,
      title: language.settings.voucher.title,
      instructions: language.settings.voucher.instructions,
      placeholder: language.settings.voucher.placeholder,
      validate: language.settings.voucher.validate,
    };

    this.DOMContainer = document.getElementById(VOUCHER_CONTAINER_ID);
    if (this.DOMContainer !== null) {
      Dust.render(voucherTemplate, context, (_err, result) => {
        this.DOMContainer.innerHTML = result;
        this.backButton = this.DOMContainer.querySelector(
          ".overlay-navigation-back .overlay-navigation-icon"
        );
        this.closeButton = this.DOMContainer.querySelector(
          ".overlay-navigation-close .overlay-navigation-icon"
        );
        this.submitButton = document.getElementById("voucher-submit");
        this.attachClickHandlers();
        this.show();
      });
    }
  }

  attachClickHandlers() {
    this._getButtonsWithHandlers().forEach(({ element, handler }) => {
      if (element) {
        element.addEventListener("click", handler);
      }
    });
  }

  _detachListeners() {
    this._getButtonsWithHandlers().forEach(({ element, handler }) => {
      if (element) {
        element.removeEventListener("click", handler);
      }
    });
  }

  _getButtonsWithHandlers() {
    // handlers are bound such that the same function reference is used for both
    // adding and removing event listeners
    return [
      { element: this.backButton, handler: this.onBackButtonClick.bind(this) },
      {
        element: this.closeButton,
        handler: this.onCloseButtonClick.bind(this),
      },
      { element: this.submitButton, handler: this.onSubmit.bind(this) },
    ];
  }

  onBackButtonClick(e) {
    e.stopPropagation();
    this.hide();
  }

  onCloseButtonClick(e) {
    e.stopPropagation();
    this.close();
  }

  async onSubmit(event) {
    event.stopPropagation();
    const input = document.getElementById("voucher-input");
    if (input) {
      try {
        await this._redeemVoucherAndClose(input.value);
      } catch (err) {
        this.showError(err);
        const data =
          err && err.cause && err.cause.twipeCode
            ? { twipeCode: err.cause.twipeCode }
            : undefined;
        this._appState.triggerEvent(
          VOUCHER_EVENTS.REDEEM_VOUCHER_FAILED,
          data,
          true
        );
      }
    }
  }

  async _redeemVoucherAndClose(voucher) {
    await redeemAndStoreVoucher(
      this._appState.userId,
      this._appState.sessionId,
      voucher
    );
    this.trigger("settingVoucher:redeemed");
    this._appState.triggerEvent(VOUCHER_EVENTS.REDEEM_VOUCHER_SUCCEED);
    this.hideError();
    this.close();
  }

  close() {
    this.hide();
    this.trigger("settingVoucher:closed");
  }

  hide() {
    if (this.DOMContainer !== null) {
      this.DOMContainer.innerHTML = "";
      this.DOMContainer.classList.add("hidden");
      this._detachListeners();
    }
    this._appState.triggerEvent(VOUCHER_EVENTS.CLOSED_VOUCHER_MENU);
  }

  show() {
    if (this.DOMContainer !== null) {
      this.DOMContainer.classList.remove("hidden");
    }
    this._appState.triggerEvent(VOUCHER_EVENTS.CLICKED_VOUCHER_MENU);
  }

  hideError() {
    const errorContainer = document.getElementById(VOUCHER_ERROR_ID);
    if (errorContainer) {
      errorContainer.classList.add("hidden");
    }
  }

  showError(error) {
    const errorContainer = document.getElementById(VOUCHER_ERROR_ID);
    if (error && error.message && errorContainer) {
      const textToDisplay = error.message;
      errorContainer.innerHTML = textToDisplay;
      errorContainer.classList.remove("hidden");
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/settings/settingVoucher.js